import type { UpcomingPageSearch } from '@/components/layout/PageHeader';
import { SEARCH_COMING_SOON } from '@/constants/app.constants';

export function getUpcomingSearch(placeholder: string): UpcomingPageSearch {
  return { placeholder, upcomingReason: SEARCH_COMING_SOON };
}
